// extracted by mini-css-extract-plugin
export default {"banner":"MOGC0x"};